export default __webpack_public_path__ + "static/media/heartEmpty.93cd13b2.svg";